// Remembers city-string → {lat, lng} for this page load, so re-rendering the
// dashboard (filters, back-navigation, the in-place refresh after login) doesn't
// repeat the autocomplete + placedetails round-trips for a city it already
// resolved. Only successful lookups are kept.
const coords = new Map();

const keyOf = (input) => String(input || "").trim().toLowerCase().replace(/\s+/g, " ");

export function getCachedCoords(input) {
  return coords.get(keyOf(input)) || null;
}

export function setCachedCoords(input, lat, lng) {
  if (lat && lng) coords.set(keyOf(input), { lat, lng });
}
